


































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Translation from '@/components/i18n/Translation.vue';
import FormField from '@/components/form/FormField.vue';
import DatePicker from 'vuejs-datepicker';
import moment, { Moment } from 'moment';
import { de } from 'vuejs-datepicker/dist/locale';
import { ValidationError } from 'class-validator';
import i18next from 'i18next';
import { momentEndDay, momentStartDay } from '@/views/utils/timeCalculations';

@Component({
  components: { Translation, FormField, DatePicker },
})
export default class DateField extends Vue {
  @Prop(Object)
  public value!: Moment;

  @Prop(String)
  public identifier!: string;

  @Prop(String)
  public placeholder!: string;

  @Prop(String)
  public label!: string;

  @Prop(Boolean)
  public disabled!: boolean;

  @Prop(Boolean)
  public hasInfo!: boolean;

  @Prop(Boolean)
  public isMandatory!: boolean;

  @Prop(Boolean)
  public labelIsPath!: boolean;

  @Prop(Boolean)
  public useEndOfDay!: boolean;

  @Prop(Array)
  public options!: Array<{ value: string | number; label: string | number }>;

  @Prop(Object)
  public validationError!: ValidationError | null;

  @Prop(Array)
  public warnings!: string[] | null;

  @Prop({type: Boolean, default: false})
  public onlyCurrentYearAllowed!: boolean;

  public get dateValue(): Date | null {
    return this.value && this.value.isValid() ? this.value.toDate() : null;
  }

  public translate(path: string, params?: any): string {
    return i18next.t(path, params);
  }

  public get translatedPlaceholder(): string {
    if (!this.placeholder) {
      return '';
    }
    return this.translate(this.placeholder);
  }

  @Emit()
  public infoClick(): void {}

  public formatter(date: Date): string | null {
    return moment(date).format('DD.MM.YYYY');
  }

  public get datePickerLanguage(): Object {
    return de;
  }

  public get disabledDates(): object {
    if (!this.onlyCurrentYearAllowed) {
      return {};
    }

    const currentYear = new Date().getFullYear();

    return {
      to: new Date(currentYear, 0, 0),
      from: new Date(currentYear, 11, 31),
    };
  }

  public toMoment(date: Date): Moment {
    const momentDate = moment(date);
    let finalMoment;
    if (this.useEndOfDay) {
      finalMoment = momentEndDay(momentDate);
    } else {
      finalMoment = momentStartDay(momentDate);
    }
    return finalMoment;
  }
}
